export const roundValueToMaxPackageSize = (value: number, packageSize: number): number => Math.ceil(value / packageSize) * packageSize;

export const roundValueToMinPackageSize = (value: number, packageSize: number): number => Math.floor(value / packageSize) * packageSize;



// WEBPACK FOOTER //
// ./src/domain/roundValueToPackageSize.ts